import { amountToDisplayValue, InternalAccessor } from '@billy/design-system'

import { getOrganizationViewUrl } from '../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../utils/routing/reactRoute'
import { InvoiceDocumentType } from '../../../enums/invoiceDocumentType'
import { Quote } from '../../../types/quotes/quote'
import { getInvoiceDocumentRouteBase } from '../../../utils/getInvoiceDocumentRouteBase'
import { QuotesTableAccessor } from '../enums/quotesTableAccessor'
import { QuotesTableRow } from '../types/quotesTableRow'
import { getQuoteRowStatus } from './getQuoteRowStatus'

export const getQuotesTableData = (quotes: Quote[], organizationUrl: string | undefined): QuotesTableRow[] => {
  return quotes.map((quote) => {
    const {
      customer,
      documentType,
      dueDate,
      estimateNumber,
      id,
      invoiceState,
      issueDate,
      lines,
      locale,
      status,
      summary,
    } = quote
    const { displayName, externalContactId } = customer
    const netTotal = `${amountToDisplayValue(summary.foreignNetTotal)} ${summary.foreignCurrency}`
    const description = lines.map((line) => line.description).join(', ')
    const quoteId = id.toString()
    const routeBase = getInvoiceDocumentRouteBase(documentType)
    const isDraft = documentType === InvoiceDocumentType.QuoteDraft

    const editUrl = getOrganizationViewUrl(
      organizationUrl,
      isDraft
        ? reactRoute.organization.invoices.getEditDocumentDraftRoute(routeBase, quoteId)
        : reactRoute.organization.invoices.getEditDocumentRoute(routeBase, quoteId),
    )

    const duplicateUrl = getOrganizationViewUrl(
      organizationUrl,
      isDraft
        ? reactRoute.organization.invoices.getDuplicateDocumentDraftRoute(routeBase, quoteId)
        : reactRoute.organization.invoices.getDuplicateDocumentRoute(routeBase, quoteId),
    )

    const convertToInvoiceUrl = getOrganizationViewUrl(
      organizationUrl,
      reactRoute.organization.invoices.getInvoiceFromQuoteRoute(quoteId),
    )

    const convertToFinalInvoiceUrl = getOrganizationViewUrl(
      organizationUrl,
      reactRoute.organization.invoices.getFinalInvoiceFromQuoteRoute(quoteId),
    )

    return {
      id: quoteId,
      [QuotesTableAccessor.ContactId]: displayName,
      [QuotesTableAccessor.Description]: description,
      [QuotesTableAccessor.DocumentType]: documentType,
      [QuotesTableAccessor.DueDate]: dueDate,
      [QuotesTableAccessor.IssueDate]: issueDate,
      [QuotesTableAccessor.NetTotal]: netTotal,
      [QuotesTableAccessor.QuoteNumber]: estimateNumber,
      [QuotesTableAccessor.Status]: getQuoteRowStatus(documentType, status?.status),
      [InternalAccessor.StaticActions]: true,
      convertToFinalInvoiceUrl,
      convertToInvoiceUrl,
      deliveryStatus: status?.deliveryStatus,
      documentLocale: locale,
      duplicateUrl,
      editUrl,
      externalContactId: externalContactId ?? undefined,
      invoiceState,
      quoteStatus: status?.status,
    }
  })
}
